/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable no-nested-ternary */
import React from 'react';
import { styled } from 'linaria/react';
import Image from 'next/image';
import { useBreakpoint } from '@mtsbank/ui-kit';
import { useTheme, withTheme } from '@shared/lib';
import { ThemeType } from '@shared/types';
import { OldSpinner } from '@shared/ui/atoms';
import cup from '@shared/assets/images/cyber/promo/vesenniiRozygryshItogi/cup.png';
interface Props {
  title: string | React.ReactElement;
  onClick?: (e?: React.MouseEvent) => void;
  type?: 'button' | 'reset' | 'submit';
  isPaymentloading?: boolean;
  isAmountInfoLoading?: boolean;
  amount?: string;
  amountBase?: string;
  id?: string;
  mtsFog?: boolean;
  zoom?: boolean;
  slider?: boolean;
  steamFest?: boolean;
  promo?: boolean;
  promoModal?: boolean;
  sucssessPromo?: boolean;
  cash?: boolean;
  inarius?: boolean;
  height?: number;
  genshin?: boolean;
  mobileLegends?: boolean;
  logIn?: boolean;
  disabled?: boolean;
  pubg?: boolean;
  vesenniiRozygrysh?: boolean;
  summerSale?: boolean;
  international?: boolean;
  width?: number;
  showVouchersForm?: boolean;
  bannerButtonBgColor?: string;
  bannerButtonBgHoverColor?: string;
  bannerButtonBottomColor?: string;
  bannerButtonTextColor?: string;
  bannerButtonStartIcon?: string;
  blackSpinner?: boolean;
}
const getColor = (isLoading: boolean, mtsFog: boolean, zoom: boolean, steamFest: boolean, sucssessPromo: boolean, genshin: boolean, mobileLegends: boolean, pubg: boolean, vesenniiRozygrysh: boolean, international: boolean, theme: ThemeType, bannerButtonBgColor: string) => {
  if (bannerButtonBgColor) {
    return bannerButtonBgColor;
  }
  // if (isLoading) {
  //   return '#d60b35'
  // }
  if (mtsFog) {
    return 'linear-gradient(to right, #67A4C6, #4673B2, #8F62D8)';
  }
  if (zoom) {
    return 'linear-gradient(to right, #1D50F5, #1D50F5)';
  }
  if (steamFest) {
    return 'linear-gradient(to right, #7A3E98, #7A3E98)';
  }
  if (sucssessPromo) {
    return 'linear-gradient(to right, #6C11BD, #6C11BD)';
  }
  if (genshin) {
    return 'linear-gradient(356deg, #7E81C1 22.72%, #5259C0 100.62%)';
  }
  if (pubg) {
    return 'linear-gradient(356deg, #E78856 22.72%, #E85608 100.62%)';
  }
  if (vesenniiRozygrysh) {
    return 'linear-gradient(293deg, #FFF -40.08%, #5A91C8 69.28%)';
  }
  if (mobileLegends) {
    return '#ea1f49';
  }
  if (international) {
    return 'linear-gradient(272.56deg, #F393F9 -32.23%, #4036D4 143.38%)';
  }
  return theme.colors.state.active;
};
const getShadow = (isLoading: boolean, mtsFog: boolean, zoom: boolean, steamFest: boolean, sucssessPromo: boolean, genshin: boolean, mobileLegends: boolean, pubg: boolean, vesenniiRozygrysh: boolean, international: boolean, theme: ThemeType, bannerButtonBottomColor: string) => {
  if (bannerButtonBottomColor) {
    return `0px 4px 0px 0px ${bannerButtonBottomColor}`;
  }
  if (isLoading) {
    return 'none';
  }
  if (mtsFog) {
    return '0px 4px 0px 0px rgba(91, 51, 174, 1)';
  }
  if (zoom) {
    return '0px 4px 0px 0px rgba(29, 62, 154, 1)';
  }
  if (steamFest) {
    return '0px 4px 0px 0px rgba(74, 12, 104, 1)';
  }
  if (sucssessPromo) {
    return '0px 4px 0px 0px rgba(54, 6, 113, 1)';
  }
  if (genshin) {
    return '0px 4px 0px 0px rgba(72, 80, 178, 1)';
  }
  if (pubg) {
    return '0px 4px 0px 0px rgba(205, 54, 0, 1)';
  }
  if (vesenniiRozygrysh) {
    return '0px 4px 0px 0px rgba(55, 122, 193, 1), 0px 3px 6.7px 0px rgba(13, 79, 144, 0.61), 0px 10px 24.3px 0px rgba(13, 79, 144, 0.60), 0.5px -0.5px 1.1px 0px rgba(255, 255, 255, 0.50) inset';
  }
  if (mobileLegends) {
    return `0px 4px 0px 0px #AF0022`;
  }
  if (international) {
    return `0px 4px 0px 0px #821BB8`;
  }
  return `0px 4px 0px 0px ${theme.colors.state.buttonActive}`;
};
const PaymentButton = ({
  title,
  onClick,
  type,
  isPaymentloading,
  isAmountInfoLoading,
  amount,
  amountBase,
  id,
  mtsFog,
  slider,
  zoom,
  steamFest,
  promo,
  promoModal,
  sucssessPromo,
  cash,
  inarius,
  height = 52,
  width,
  genshin,
  mobileLegends,
  logIn,
  disabled,
  pubg,
  vesenniiRozygrysh,
  summerSale,
  international,
  showVouchersForm,
  bannerButtonBgColor,
  bannerButtonBgHoverColor,
  bannerButtonBottomColor,
  bannerButtonTextColor,
  bannerButtonStartIcon,
  blackSpinner
}: Props) => {
  const {
    isMobile
  } = useBreakpoint();
  const theme = useTheme();
  return <ButtonWrapper id={id}
  // @ts-ignore
  isLoading={isPaymentloading} type={type} onClick={onClick}
  // @ts-ignore
  disabled={amountBase === '0' || !!(isPaymentloading || amount === '0') || disabled} amountBase={amountBase} showVouchersForm={showVouchersForm} isMobile={isMobile} mtsFog={mtsFog} zoom={zoom} slider={slider} steamFest={steamFest} promoModal={promoModal} sucssessPromo={sucssessPromo} height={height} width={width} genshin={genshin} mobileLegends={mobileLegends} pubg={pubg} vesenniiRozygrysh={vesenniiRozygrysh} bannerButtonBgColor={bannerButtonBgColor} bannerButtonBgHoverColor={bannerButtonBgHoverColor} bannerButtonBottomColor={bannerButtonBottomColor} international={international}>
      {/* @ts-ignore */}
      <Text bannerButtonTextColor={bannerButtonTextColor}>
        {isPaymentloading && <WrapperIcon>
            <OldSpinner small blackSpinner={blackSpinner} />
            <div>{promoModal ? '' : 'Обработка платежа'}</div>
          </WrapperIcon>}
        {isAmountInfoLoading && <OldSpinner small blackSpinner={blackSpinner} />}
        {!isPaymentloading && !isAmountInfoLoading && <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px'
      }}>
            {vesenniiRozygrysh && <Image src={cup} alt="cup" width={24} height={24} />}
            {promo && <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                <path fillRule="evenodd" clipRule="evenodd" d="M12.5 4C10.9502 4 9.59788 4.06763 8.44509 4.16772C6.42076 4.34348 5.4086 4.43136 4.11923 5.72515C2.82986 7.01894 2.74897 7.98922 2.58718 9.92978C2.53307 10.5788 2.5 11.2729 2.5 12C2.5 14.0039 2.75114 15.7568 3.0018 17.0072C3.25194 18.2552 4.26664 19.1602 5.51241 19.421C6.74518 19.679 8.02023 19.269 8.89221 18.3602C10.0982 17.1032 11.696 15.5 12 15.5H13C13.304 15.5 14.9018 17.1032 16.1078 18.3601C16.9798 19.269 18.2548 19.679 19.4876 19.4211C20.7338 19.1603 21.7487 18.2548 21.9987 17.0065C22.2491 15.756 22.5 14.0035 22.5 12C22.5 11.2736 22.467 10.5802 22.413 9.9317C22.2514 7.9901 22.1706 7.0193 20.8811 5.72528C19.5917 4.43126 18.579 4.34338 16.5538 4.16761C15.4012 4.06758 14.0492 4 12.5 4ZM16 10.5C16 11.0523 15.5523 11.5 15 11.5C14.4477 11.5 14 11.0523 14 10.5C14 9.94772 14.4477 9.5 15 9.5C15.5523 9.5 16 9.94772 16 10.5ZM18.5 11.5C19.0523 11.5 19.5 11.0523 19.5 10.5C19.5 9.94772 19.0523 9.5 18.5 9.5C17.9477 9.5 17.5 9.94772 17.5 10.5C17.5 11.0523 17.9477 11.5 18.5 11.5ZM16.75 11.25C17.3023 11.25 17.75 11.6977 17.75 12.25C17.75 12.8023 17.3023 13.25 16.75 13.25C16.1977 13.25 15.75 12.8023 15.75 12.25C15.75 11.6977 16.1977 11.25 16.75 11.25ZM17.75 8.75C17.75 8.19772 17.3023 7.75 16.75 7.75C16.1977 7.75 15.75 8.19772 15.75 8.75C15.75 9.30228 16.1977 9.75 16.75 9.75C17.3023 9.75 17.75 9.30228 17.75 8.75ZM8.25 7.75C8.80228 7.75 9.25 8.19772 9.25 8.75V9.5H10C10.5523 9.5 11 9.94772 11 10.5C11 11.0523 10.5523 11.5 10 11.5H9.25V12.25C9.25 12.8023 8.80228 13.25 8.25 13.25C7.69772 13.25 7.25 12.8023 7.25 12.25V11.5H6.5C5.94772 11.5 5.5 11.0523 5.5 10.5C5.5 9.94772 5.94772 9.5 6.5 9.5H7.25V8.75C7.25 8.19772 7.69772 7.75 8.25 7.75Z" fill={theme.colors.icon.white} />
              </svg>}
            {inarius && <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                <path fillRule="evenodd" clipRule="evenodd" d="M4.71474 5.12452C4.96317 5.09239 5.22732 5.06366 5.5 5.04191V4.99881C5.5 3.89426 6.39449 3.00001 7.49905 3L17.501 3C18.6055 3.00001 19.5 3.89426 19.5 4.99881V5.04191C19.7727 5.06366 20.0368 5.09239 20.2853 5.12452C21.3841 5.26662 22.2333 6.11592 22.3754 7.2147C22.4459 7.75946 22.5 8.37971 22.5 8.99997C22.5 11.21 20.7101 13 18.5 13C18.239 13 17.978 12.9904 17.7226 12.974C16.8687 13.8466 15.7572 14.4773 14.5 14.7857V16.5395C15.1897 16.8153 15.9528 17.1841 16.5971 17.6512C18.2406 18.8427 18.5 19.8863 18.5 20.5575C18.5 20.6758 18.4951 20.8253 18.4781 20.998H6.52177C6.50483 20.8253 6.5 20.6758 6.5 20.5575C6.5 19.8863 6.75945 18.8427 8.40295 17.6512C9.03951 17.1898 9.80318 16.8242 10.5 16.5495V14.7856C9.24285 14.4772 8.13134 13.8466 7.27751 12.974C7.02209 12.9904 6.76105 13 6.5 13C4.28994 13 2.5 11.21 2.5 8.99997C2.5 8.37971 2.5541 7.75946 2.62455 7.2147C2.76665 6.11592 3.61595 5.26662 4.71474 5.12452ZM5.50009 8.56744L5.5 8.50001V7.04925C5.32026 7.0658 5.14308 7.08578 4.97125 7.108C4.77358 7.13356 4.6336 7.27354 4.60803 7.47122C4.54496 7.95893 4.5 8.48973 4.5 8.99997C4.5 9.91218 5.10907 10.6807 5.94317 10.9216C5.65888 10.2027 5.50231 9.41161 5.50009 8.56744ZM19.4999 8.56768C19.4977 9.41175 19.3411 10.2028 19.0569 10.9216C19.891 10.6807 20.5 9.91216 20.5 8.99997C20.5 8.48973 20.455 7.95893 20.392 7.47122C20.3664 7.27354 20.2264 7.13356 20.0287 7.108C19.8569 7.08578 19.6797 7.0658 19.5 7.04925V8.50001L19.4999 8.56768Z" fill={theme.colors.icon.white} />
              </svg>}
            {cash && <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M8.44465 4.66773C9.59742 4.56764 10.9498 4.5 12.4995 4.5C14.0488 4.5 15.4007 4.56759 16.5533 4.66762C18.5784 4.84338 19.591 4.93126 20.8803 6.22523C21.6587 7.00633 21.9966 7.66966 22.1778 8.49984H2.82149C3.00266 7.66963 3.34056 7.00634 4.11911 6.2251C5.40837 4.93136 6.42046 4.84348 8.44465 4.66773ZM2.58142 10.4998H22.4177C22.4684 11.1285 22.4991 11.7988 22.4991 12.4997C22.4991 13.2262 22.4661 13.9196 22.4121 14.5681C22.2505 16.5095 22.1697 17.4802 20.8803 18.7742C19.591 20.0681 18.5785 20.156 16.5535 20.3318C15.4009 20.4318 14.0489 20.4994 12.4996 20.4994C10.9497 20.4994 9.5973 20.4318 8.44449 20.3317C6.42039 20.1559 5.40835 20.068 4.11911 18.7743C2.82986 17.4806 2.74897 16.5104 2.58718 14.5699C2.53307 13.9209 2.5 13.2268 2.5 12.4997C2.5 11.7988 2.53073 11.1285 2.58142 10.4998ZM18.7484 14.4996C18.7484 15.1899 18.1888 15.7495 17.4985 15.7495C16.8082 15.7495 16.2486 15.1899 16.2486 14.4996C16.2486 13.8093 16.8082 13.2496 17.4985 13.2496C18.1888 13.2496 18.7484 13.8093 18.7484 14.4996Z" fill={theme.colors.icon.white} />
              </svg>}
            {logIn && <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path fillRule="evenodd" clipRule="evenodd" d="M4.68206 4.68597C3.36919 5.99884 3.27184 7.30684 3.07715 9.92282C3.02668 10.601 2.99609 11.3005 2.99609 12C2.99609 12.6995 3.02668 13.399 3.07715 14.0772C3.27184 16.6932 3.36919 18.0012 4.68206 19.314C5.99494 20.6269 7.30293 20.7243 9.91892 20.9189C10.597 20.9694 11.2966 21 11.9961 21C12.6956 21 13.3951 20.9694 14.0733 20.9189C16.6893 20.7243 17.9973 20.6269 19.3101 19.314C20.623 18.0012 20.7203 16.6932 20.915 14.0772C20.9655 13.399 20.9961 12.6995 20.9961 12C20.9961 11.3005 20.9655 10.601 20.915 9.92282C20.7203 7.30684 20.623 5.99884 19.3101 4.68597C17.9973 3.3731 16.6893 3.27575 14.0733 3.08105C13.3951 3.03058 12.6956 3 11.9961 3C11.2966 3 10.597 3.03058 9.91892 3.08105C7.30293 3.27575 5.99494 3.3731 4.68206 4.68597ZM8.49475 9.99976C8.49475 8.06609 10.0623 6.49854 11.996 6.49854C13.9296 6.49854 15.4972 8.06609 15.4972 9.99976C15.4972 11.9334 13.9296 13.501 11.996 13.501C10.0623 13.501 8.49475 11.9334 8.49475 9.99976ZM12.8456 15.0212C14.3922 15.0985 15.9132 15.4613 18.6992 16.1665C18.5536 17.0805 18.344 17.4515 17.8959 17.8996C17.1897 18.6058 16.6752 18.7196 13.9248 18.9242C13.2877 18.9717 12.6383 18.9998 11.9961 18.9998C11.3539 18.9998 10.7045 18.9717 10.0674 18.9242C7.317 18.7196 6.80247 18.6058 6.09628 17.8996C5.64818 17.4515 5.43861 17.0806 5.29298 16.1667C8.08216 15.4611 9.60463 15.0981 11.1513 15.0211C11.4327 15.007 11.7143 15 11.996 15C12.2793 15 12.5626 15.007 12.8456 15.0212Z" fill={theme.colors.icon.white} />
              </svg>}
            {summerSale && <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 0C11.3132 0 12.6136 0.258658 13.8268 0.761205C15.0401 1.26375 16.1425 2.00035 17.0711 2.92893C17.9997 3.85752 18.7362 4.95991 19.2388 6.17317C19.7413 7.38642 20 8.68678 20 10C20 12.6522 18.9464 15.1957 17.0711 17.0711C15.1957 18.9464 12.6522 20 10 20C5.4 20 1.55 16.92 0.36 12.73L4.19 14.31C4.32124 14.9506 4.66949 15.5262 5.17597 15.9398C5.68245 16.3534 6.31612 16.5795 6.97 16.58C8.53 16.58 9.8 15.31 9.8 13.75V13.62L13.2 11.19H13.28C15.36 11.19 17.05 9.5 17.05 7.42C17.05 5.34 15.36 3.65 13.28 3.65C11.2 3.65 9.5 5.34 9.5 7.42V7.47L7.13 10.93L6.97 10.92C6.38 10.92 5.83 11.1 5.38 11.41L0 9.2C0.43 4.05 4.73 0 10 0ZM6.28 15.17C7.08 15.5 8 15.13 8.33 14.33C8.66 13.53 8.28 12.62 7.5 12.29L6.22 11.76C6.71 11.58 7.26 11.57 7.78 11.79C8.31 12 8.72 12.41 8.93 12.94C9.15 13.46 9.15 14.04 8.93 14.56C8.5 15.64 7.23 16.16 6.15 15.71C5.65 15.5 5.27 15.12 5.06 14.67L6.28 15.17ZM15.8 7.42C15.8 8.81 14.67 9.94 13.28 9.94C12.6134 9.93735 11.975 9.67069 11.5046 9.19838C11.0341 8.72608 10.77 8.08662 10.77 7.42C10.7687 7.09001 10.8327 6.76303 10.9584 6.4579C11.084 6.15278 11.2689 5.87555 11.5022 5.64221C11.7356 5.40887 12.0128 5.22404 12.3179 5.09837C12.623 4.9727 12.95 4.90868 13.28 4.91C13.9466 4.90999 14.5861 5.17412 15.0584 5.64455C15.5307 6.11498 15.7974 6.75339 15.8 7.42ZM11.4 7.42C11.4 8.46 12.24 9.31 13.29 9.31C14.33 9.31 15.17 8.46 15.17 7.42C15.17 6.38 14.33 5.53 13.29 5.53C12.24 5.53 11.4 6.38 11.4 7.42Z" fill="white" />
              </svg>}
            {bannerButtonStartIcon && <BannerButtonStartIconWrapper>
                <Image alt="start-icon" width={20} height={20} src={bannerButtonStartIcon} />
              </BannerButtonStartIconWrapper>}
            {international && <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 0C11.3132 0 12.6136 0.258658 13.8268 0.761205C15.0401 1.26375 16.1425 2.00035 17.0711 2.92893C17.9997 3.85752 18.7362 4.95991 19.2388 6.17317C19.7413 7.38642 20 8.68678 20 10C20 12.6522 18.9464 15.1957 17.0711 17.0711C15.1957 18.9464 12.6522 20 10 20C5.4 20 1.55 16.92 0.36 12.73L4.19 14.31C4.32124 14.9506 4.66949 15.5262 5.17597 15.9398C5.68245 16.3534 6.31612 16.5795 6.97 16.58C8.53 16.58 9.8 15.31 9.8 13.75V13.62L13.2 11.19H13.28C15.36 11.19 17.05 9.5 17.05 7.42C17.05 5.34 15.36 3.65 13.28 3.65C11.2 3.65 9.5 5.34 9.5 7.42V7.47L7.13 10.93L6.97 10.92C6.38 10.92 5.83 11.1 5.38 11.41L0 9.2C0.43 4.05 4.73 0 10 0ZM6.28 15.17C7.08 15.5 8 15.13 8.33 14.33C8.66 13.53 8.28 12.62 7.5 12.29L6.22 11.76C6.71 11.58 7.26 11.57 7.78 11.79C8.31 12 8.72 12.41 8.93 12.94C9.15 13.46 9.15 14.04 8.93 14.56C8.5 15.64 7.23 16.16 6.15 15.71C5.65 15.5 5.27 15.12 5.06 14.67L6.28 15.17ZM15.8 7.42C15.8 8.81 14.67 9.94 13.28 9.94C12.6134 9.93735 11.975 9.67069 11.5046 9.19838C11.0341 8.72608 10.77 8.08662 10.77 7.42C10.7687 7.09001 10.8327 6.76303 10.9584 6.4579C11.084 6.15278 11.2689 5.87555 11.5022 5.64221C11.7356 5.40887 12.0128 5.22404 12.3179 5.09837C12.623 4.9727 12.95 4.90868 13.28 4.91C13.9466 4.90999 14.5861 5.17412 15.0584 5.64455C15.5307 6.11498 15.7974 6.75339 15.8 7.42ZM11.4 7.42C11.4 8.46 12.24 9.31 13.29 9.31C14.33 9.31 15.17 8.46 15.17 7.42C15.17 6.38 14.33 5.53 13.29 5.53C12.24 5.53 11.4 6.38 11.4 7.42Z" fill="white" />
              </svg>}
            {title}
          </div>}
      </Text>
    </ButtonWrapper>;
};
export default PaymentButton;
const _exp = /*#__PURE__*/() => ({
  amountBase,
  showVouchersForm
}) => amountBase !== '0' && showVouchersForm || !showVouchersForm ? 'pointer' : 'default';
const _exp2 = /*#__PURE__*/() => ({
  isMobile
}) => isMobile ? '0 10px' : '0 14px';
const _exp5 = /*#__PURE__*/() => ({
  isLoading,
  mtsFog,
  zoom,
  steamFest,
  sucssessPromo,
  genshin,
  mobileLegends,
  pubg,
  vesenniiRozygrysh,
  international,
  theme,
  bannerButtonBgColor
}) => getColor(isLoading, mtsFog as boolean, zoom as boolean, steamFest as boolean, sucssessPromo as boolean, genshin as boolean, mobileLegends as boolean, pubg as boolean, vesenniiRozygrysh as boolean, international as boolean, theme, bannerButtonBgColor as string);
const _exp8 = /*#__PURE__*/() => ({
  isLoading,
  mtsFog,
  zoom,
  steamFest,
  sucssessPromo,
  genshin,
  mobileLegends,
  pubg,
  vesenniiRozygrysh,
  international,
  theme,
  bannerButtonBottomColor
}) => getShadow(isLoading, mtsFog as boolean, zoom as boolean, steamFest as boolean, sucssessPromo as boolean, genshin as boolean, mobileLegends as boolean, pubg as boolean, vesenniiRozygrysh as boolean, international as boolean, theme, bannerButtonBottomColor as string);
const _exp9 = /*#__PURE__*/() => ({
  amountBase,
  showVouchersForm
}) => amountBase === '0' && showVouchersForm && '0.4' as any;
const _exp0 = /*#__PURE__*/() => ({
  isMobile,
  theme,
  amountBase,
  showVouchersForm,
  mobileLegends,
  bannerButtonBgHoverColor
}) => bannerButtonBgHoverColor || (mobileLegends ? '#fe335d' : isMobile || amountBase === '0' && showVouchersForm ? theme.colors.state.active : theme.colors.state.hover);
const _exp1 = /*#__PURE__*/() => ({
  disabled,
  theme,
  amountBase,
  showVouchersForm,
  mobileLegends
}) => mobileLegends ? '#AF0022' : amountBase === '0' && showVouchersForm ? theme.colors.state.active : disabled ? theme.colors.state.hover : theme.colors.state.buttonActive;
const _exp10 = /*#__PURE__*/() => ({
  disabled
}) => disabled ? 'none' : 'translateY(4px)';
const _exp11 = /*#__PURE__*/() => ({
  amountBase,
  isLoading,
  mtsFog,
  zoom,
  steamFest,
  sucssessPromo,
  genshin,
  mobileLegends,
  pubg,
  vesenniiRozygrysh,
  theme,
  showVouchersForm,
  bannerButtonBottomColor,
  international
}) => amountBase === '0' && showVouchersForm ? getShadow(isLoading, mtsFog as boolean, zoom as boolean, steamFest as boolean, sucssessPromo as boolean, genshin as boolean, mobileLegends as boolean, pubg as boolean, vesenniiRozygrysh as boolean, international as boolean, theme, bannerButtonBottomColor as string) : 'none';
const _exp12 = /*#__PURE__*/() => ({
  slider,
  height
}) => slider ? '40' : height as number;
const _exp13 = /*#__PURE__*/() => ({
  slider
}) => slider ? '80%' : '100%';
const _exp14 = /*#__PURE__*/() => ({
  height
}) => height as number;
const _exp15 = /*#__PURE__*/() => ({
  width
}) => width ? `${width}px` : '100%';
const ButtonWrapper = withTheme(/*#__PURE__*/styled('button')({
  name: "ButtonWrapper",
  class: "bb2m6vm",
  propsAsIs: false,
  vars: {
    "bb2m6vm-0": [_exp()],
    "bb2m6vm-1": [_exp2()],
    "bb2m6vm-2": [_exp14(), "px"],
    "bb2m6vm-3": [_exp15()],
    "bb2m6vm-4": [_exp5()],
    "bb2m6vm-5": [_exp8()],
    "bb2m6vm-6": [_exp9()],
    "bb2m6vm-7": [_exp0()],
    "bb2m6vm-8": [_exp1()],
    "bb2m6vm-9": [_exp10()],
    "bb2m6vm-10": [_exp11()],
    "bb2m6vm-11": [_exp12(), "px"],
    "bb2m6vm-12": [_exp13()]
  }
}));
interface TextProps {
  bannerButtonTextColor: string;
}
const _exp16 = /*#__PURE__*/() => ({
  theme
}) => theme.font.family.MTSWide;
const _exp17 = /*#__PURE__*/() => ({
  theme
}) => theme.font.size.xxxs;
const _exp18 = /*#__PURE__*/() => ({
  theme
}) => theme.font.weight.bold;
const _exp19 = /*#__PURE__*/() => ({
  theme
}) => theme.font.lineHeight.xxxs;
const _exp20 = /*#__PURE__*/() => ({
  bannerButtonTextColor,
  theme
}) => bannerButtonTextColor || theme.colors.text.white;
const Text = withTheme(/*#__PURE__*/styled('div')({
  name: "Text",
  class: "t1e83l4v",
  propsAsIs: false,
  vars: {
    "t1e83l4v-0": [_exp16()],
    "t1e83l4v-1": [_exp17(), "px"],
    "t1e83l4v-2": [_exp18()],
    "t1e83l4v-3": [_exp19(), "px"],
    "t1e83l4v-4": [_exp20()]
  }
}));
const WrapperIcon = /*#__PURE__*/styled('div')({
  name: "WrapperIcon",
  class: "w1c52djl",
  propsAsIs: false
});
const BannerButtonStartIconWrapper = /*#__PURE__*/styled('div')({
  name: "BannerButtonStartIconWrapper",
  class: "bnviehf",
  propsAsIs: false
});

require("./PaymentButton.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./PaymentButton.tsx");